export default __webpack_public_path__ + "static/pn-05637da543c0bea6b0ae349807387695.svg";